import { Constants, SCHEDULE_DROPDOWN, DATE_VALIDATION_TYPE, DATE_VALIDATION_MESSAGE } from "@/utils/constants/commonConstants";

export const useDatePickerInput = (fieldName, validationRules = []) => {
  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [month, day, year] = dateString.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const isSameYear = (date) => date?.getFullYear() === new Date().getFullYear();
  const isSameMonth = (date) =>
    isSameYear &&
    date?.getMonth() === new Date().getMonth();

  const validateDateDiff = (startDate, endDate) => {
    if (!startDate || !endDate) return null;
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return (endDate - startDate) / (1000 * 60 * 60 * 24);
  };

  const addError = (errorList, label, message) => {
    errorList.push(`${label} ${message}`);
  };

  const validateRequired = (selectedDate, rule, label, errorList) => {
    if (rule.type === Constants.Required && !selectedDate) {
      addError(errorList, label, rule.msg);
    }
  };

  const validateStartDate = (selectedDate, rule, label, errorList) => {
    const parsedDate = parseDate(selectedDate);
    const parsedEndDate = parseDate(rule.endDate);

    if (rule.type === DATE_VALIDATION_TYPE.START_DATE) {
      if (parsedDate < new Date()) {
        addError(errorList, label, rule.msg);
      }
      if (parsedEndDate && validateDateDiff(parsedDate, parsedEndDate) > 0) {
        addError(errorList, label, DATE_VALIDATION_MESSAGE.CAN_NOT_BE_GREATOR_THAN_END_DATE);
      }
    }
  };

  const validateEndDate = (selectedDate, rule, label, errorList) => {
    const parsedDate = parseDate(selectedDate);
    const parsedStartDate = parseDate(rule.startDate);

    if (rule.type === DATE_VALIDATION_TYPE.END_DATE && parsedStartDate) {
      if (validateDateDiff(parsedStartDate, parsedDate) < 0) {
        addError(errorList, label, rule.msg);
      }
    }
  };

  const validateSchedule = (selectedDate, rule, label, errorList) => {
    const parsedDate = parseDate(selectedDate);

    if (rule.type === DATE_VALIDATION_TYPE.SCHEDULE_YEAR && rule?.schedule?.toLowerCase() === SCHEDULE_DROPDOWN.END_OF_YEAR) {
      if (!isSameYear(parsedDate)) {
        addError(errorList, label, rule.msg);
      }
    }

    if (rule.type === DATE_VALIDATION_TYPE.SCHEDULE && rule?.schedule?.toLowerCase() === SCHEDULE_DROPDOWN.END_OF_MONTH) {
      if (!isSameMonth(parsedDate)) {
        addError(errorList, label, rule.msg);
      }
    }
  };

  const validateDates = (selectedDate) => {
    const errorList = [];
    const label = fieldName.replace("*", "");

    validationRules.forEach((rule) => {
      validateRequired(selectedDate, rule, label, errorList);
      validateStartDate(selectedDate, rule, label, errorList);
      validateEndDate(selectedDate, rule, label, errorList);
      validateSchedule(selectedDate, rule, label, errorList);
    });

    return errorList[0];
  };

  return {
    validateDates,
  };
};